import { ReactNode } from "react"
import { Heading } from "@chakra-ui/react"

import StbtcSuccessScreen from "#/ui-old/Stbtc/StbtcSuccessScreen"

type StackMatsnetBtcSuccessModalProps = {
  children: ReactNode
}

export default function StackMatsnetBtcSuccessModal({
  children,
}: StackMatsnetBtcSuccessModalProps) {
  return (
    <StbtcSuccessScreen
      bodyProps={{ bg: "primary.black.100", color: "primary.white.100" }}
      header={<Heading variant="h2">{children}</Heading>}
    />
  )
}
